import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IframeComponent } from './iframe/iframe.component';
import { LoginComponent } from './login/login.component';
import { AppConfig, ConfigService } from '@services/config.service';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { LoaderInterceptorService } from './interceptor/loader.interceptor';
import { ClientsModule } from '@clients/clients.module';
import { SharedModule } from '@shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from './layout/layout.module';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgxTranslationService } from '@services/ngxTranslation.service';
import { NotFoundComponent } from './404/404.component';
import { RecipesModule } from '@recipes/recipes.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorIntlService } from '@shared/services/paginator-intl.service';
import { ContentsModule } from '@contents/contents.module';
import { PartnersModule } from '@partners/partners.module';
import { PacksModule } from '@packs/packs.module';
import { ModerationModule } from '@moderation/moderation.module';
import { Observable } from 'rxjs';
import { CommunitiesRecipesModule } from './communities-recipes/communities-recipes.module';
import { ReleaseNoteButtonComponent } from './layout/releaseNoteButton/release-note-button.component';

export const appInit = (appConfigService: ConfigService) => (): Observable<AppConfig> => appConfigService.load();

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    ClientsModule,
    RecipesModule,
    LayoutModule,
    ContentsModule,
    CommunitiesRecipesModule,
    PartnersModule,
    PacksModule,
    ModerationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: NgxTranslationService,
        deps: [HttpClient],
      },
    }),
    ReleaseNoteButtonComponent,
  ],
  declarations: [AppComponent, IframeComponent, LoginComponent, NotFoundComponent],
  providers: [
    ConfigService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [ConfigService],
    },
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntlService,
      deps: [TranslateService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
